import React from "react";
import { ZoomImageModal } from "../../../components/ZoomImageModal/ZoomImageModal";

export function ActivationImageModal({ isOpen, onClose, imageUrl, isLoading, onDownload }) {
  return (
    <ZoomImageModal
      isOpen={isOpen}
      onClose={onClose}
      imageUrl={imageUrl}
      isLoading={isLoading}
      title="Activation Image"
      onDownload={onDownload}
      size="xl"
    />
  );
}